var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.coach.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.coach.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.name"),
                            prop: "name"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.lastName"),
                            prop: "lastName"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.team.singular"),
                            prop: "team"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.teams == null,
                                      expression: "options.teams == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing || _vm.isClubManager,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.team,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "team", $$v)
                                    },
                                    expression: "model.team"
                                  }
                                },
                                [
                                  _vm.options.teams
                                    ? _vm._l(_vm.options.teams, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.picture")
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "coach-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.picture.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.picture.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus coach-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.attachFileToModel },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.dni"),
                            prop: "dni"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.dni,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dni", $$v)
                                  },
                                  expression: "model.dni"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.birthdate"),
                            prop: "birthdate"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  format: "dd-MM-yyyy",
                                  type: "date",
                                  placeholder: "Pick a day"
                                },
                                model: {
                                  value: _vm.model.birthdate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "birthdate", $$v)
                                  },
                                  expression: "model.birthdate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.email"),
                            prop: "email"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.phone"),
                            prop: "phone"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.save))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.cancel))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f228cc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f228cc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-form.vue
// module id = null
// module chunks = 